/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Contact_P1Inputs */

const es_tyc_contact_p1 = /** @type {(inputs: Tyc_Contact_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para preguntas sobre estos Terminos, contactenos en:`)
};

const en_tyc_contact_p1 = /** @type {(inputs: Tyc_Contact_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For questions about these Terms, contact us at:`)
};

/**
* | output |
* | --- |
* | "For questions about these Terms, contact us at:" |
*
* @param {Tyc_Contact_P1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_contact_p1 = /** @type {((inputs?: Tyc_Contact_P1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Contact_P1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_contact_p1(inputs)
	return en_tyc_contact_p1(inputs)
});
export { tyc_contact_p1 as "tyc.contact.p1" }